import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-close',
  templateUrl: './close.component.html',
  styleUrls: ['./close.component.css'],
  standalone: false
})
export class CloseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.top.close();
  }

}
